import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { actions } from 'redux/actions';
import { ACTIONS_TYPES } from 'redux/helper';

export const Tags = ({ repoName, registryId }) => {
  const { [ACTIONS_TYPES.CONTAINER_REGISTRY.REPOSITORY.GET_TAGS]: registryTags = {} } = useSelector((e) => e);

  const tags = registryTags[registryId] || {};
  const repoTags = tags[repoName]?.slice(0, 3) || [];

  useEffect(() => {
    if (repoName && repoTags.length === 0) {
      actions.containerRegistry.repository.getTags({ repoName, registryId });
    }
    // eslint-disable-next-line
  }, [repoName, registryId]);

  return (
    <div>
      Tags:
      {' '}
      {repoTags?.join?.(', ') || '-'}
    </div>
  );
};
